module.exports = __webpack_public_path__ + "img/afrikai_aktualitasok_katonaipuccs_niger_AFP.6f59d5fd.png";